const NavLinks = {
  OTS_LSC_BULK_ROOT: '/ots/lscbulk',
  OTS_LSC_BULK_RECERTIFICATION_SELECTION: '/ots/lscbulk/recertification/selection',
  OTS_LSC_BULK_RECERTIFICATION: '/ots/lscbulk/recertification',
  OTS_LSC_BULK_RECERTIFICATION_DETAIL: '/ots/lscbulk/recertification/detail'
};

export default NavLinks;